import {
  FETCH_SLIDER,
  SUBMIT_SLIDER,
  DELETE_SLIDER,
  REFRESH_SLIDER_DATATABLES,
  RESET_STORE,
} from '../actions/_types';

const initialState = {
  result: [],
  submitResult: {},
  deleteResult: {},

  refresh: false,
};

export default function slider(state = initialState, action) {
  switch (action.type) {
    case FETCH_SLIDER:
      return {
        ...state,
        result: action.result,
      };

    case SUBMIT_SLIDER:
      return {
        ...state,
        submitResult: action.result,
      };

    case DELETE_SLIDER:
      return {
        ...state,
        deleteResult: action.result,
      };

    case REFRESH_SLIDER_DATATABLES:
      return {
        ...state,
        refresh: !state.refresh,
      };

    case RESET_STORE:
      return { ...initialState };

    default:
      return state;
  }
}
